/* eslint-disable no-case-declarations */
import EventEmitter from '@remote/utils/event-emitter'
import { reportPlayVideo } from '@remote/utils/logger'
import { getShubResource } from '@remote/api/adapter/api-http'

export const HeziPCClientMessage = new EventEmitter(['message'])

export function isHeziPCClient (): boolean {
  return !!window.HeziPCClient
}

export function setWin (action: 'winHide' | 'winMinimize' | 'winMaximize' | 'winRestore') {
  if (window.HeziPCClient && window.HeziPCClient?.menubar) {
    window.HeziPCClient?.menubar[action]()
  }
}

export function playVideo (url: string, video: string) {
  console.log('playVideo web')
  if (isHeziPCClient()) {
    console.log('call playVideo web')
    try {
      window.HeziPCClient?.playVideo(url, video)
    } catch (err) {
      console.log('playVideo:', err)
    }
  }
}

export async function isNearBy (ip: string) {
  let isNear = false
  let timer: NodeJS.Timeout
  const controller = new AbortController()
  try {
    await new Promise((resolve, reject) => {
      fetch(`http://${ip}:34543/detect`, {
        signal: controller.signal,
      })
        .then(res => res.json())
        .then(() => {
          isNear = true
          resolve(true)
        }).catch(() => {
          reject()
        }).finally(() => {
          timer && clearTimeout(timer)
        })

      timer = setTimeout(() => {
        reject()
        controller.abort()
      }, 50)
    })
  } catch (err) {
    console.log(err)
  }
  return isNear
}

function onHeziPCClientMessage (event: string, ...args: unknown[]) {
  console.log('onHeziPCClientMessage:', event, ...args)
  try {
    switch (event) {
      case 'REPORT_PLAYBACK_PROGRESS':
        reportPlaybackProgress(args[0] as string, args[1] as number)
          .then(() => document.dispatchEvent(new CustomEvent('refreshRecentNFOList')))
        break
      case 'SWITCH_VIDEO_QUALITY':
        console.log('切换画质')
        const mediaId = args[0] as string
        getShubResource(mediaId)
          .then(res => {
            const [err, result] = res
            if (err && result.code !== 200) {
              console.log('切换失败', err, result.msg)
            } else {
              const file = args[1] as API_FILE.DriveFile
              const playSeconds = args[2] as number
              let resolutionName = file.resolution_name
              const medias = file.medias?.map(item => {
                if (item.media_id === mediaId && item.link?.url) {
                  item.link.url = result.data.SignedURL
                  resolutionName = item.media_name as string
                }
                return item
              })
              playVideo(
                result.data.SignedURL,
                JSON.stringify({
                  ...file,
                  play_seconds: playSeconds,
                  medias,
                  resolution_name: resolutionName,
                  web_content_link: result.data.SignedURL,
                  isSwitchQuality: true,
                }),
              )
            }
            console.log('SWITCH_VIDEO_QUALITY:', res)
          })
        break
      default:
        console.log('未定义的事件名')
        break
    }
    HeziPCClientMessage.trigger('message', event, ...args)
  } catch (err) {
    console.log('onHeziPCClientMessage err', err)
  }
}

function reportPlaybackProgress (id: string, duration: number) {
  return reportPlayVideo(id, duration)
}

export function getHeziClientVersion (): string {
  if (isHeziPCClient()) {
    return window.HeziPCClient.version
  } else {
    return ''
  }
}

export function checkUpdate () {
  if (isHeziPCClient()) {
    return window.HeziPCClient.checkUpdate()
  } else {
    throw '请在盒子客户端中使用该接口'
  }
}

if (isHeziPCClient()) window.HeziPCClient.onHeziPCClientMessage = onHeziPCClientMessage